import "ant-design-vue/es/message/style";
import _message from "ant-design-vue/es/message";
import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-410b0877"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "page-intro"
};
var _hoisted_2 = /*#__PURE__*/_createStaticVNode("<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-410b0877><rect width=\"20\" height=\"20\" rx=\"10\" transform=\"matrix(-1 0 0 1 20 0)\" fill=\"white\" data-v-410b0877></rect><rect x=\"-0.3125\" y=\"0.3125\" width=\"19.375\" height=\"19.375\" rx=\"9.6875\" transform=\"matrix(-1 0 0 1 19.375 0)\" stroke=\"black\" stroke-opacity=\"0.15\" stroke-width=\"0.625\" data-v-410b0877></rect><path d=\"M10.5237 7.08252L7.60701 9.99919L10.5237 12.9159\" stroke=\"black\" stroke-opacity=\"0.65\" stroke-width=\"0.833333\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-410b0877></path></svg><span class=\"back\" data-v-410b0877>返回</span>", 2);
var _hoisted_4 = [_hoisted_2];
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "title"
  }, "活动介绍", -1);
});
var _hoisted_6 = {
  class: "page-main"
};
var _hoisted_7 = {
  class: "page-inner-container"
};
var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "target"
  }, null, -1);
});
import ItemDetailBox from '@/components/ItemDetailBox.vue';
import ItemDetailNavBar from '@/components/ItemDetailNavBar.vue';
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { DaoService } from '@/services/dao.service';
import { useService } from '@kaokei/use-vue-service';
export default /*#__PURE__*/_defineComponent({
  setup: function (__props) {
    var _this = this;
    var router = useRouter();
    var route = useRoute();
    var daoService = useService(DaoService);
    var itemList = ref([]);
    var contestNavigationBarRespList = ref([]);
    var appendixUrlList = ref([]);
    var extraFileHtml = ref('');
    var createExtraFileHtml = function (data) {
      var txt = '<ul>';
      return txt.concat(data.map(function (url, index) {
        var name = decodeURIComponent(url.split('/').pop());
        return "<li><a href=\"".concat(url, "\" target=\"_blank\">").concat(name, "</a></li>");
      }).join('<a-divider></a-divider>')).concat('</ul>');
    };
    onMounted(function () {
      return __awaiter(_this, void 0, void 0, function () {
        var encryptId, res, list, _e_1;
        var _a;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              encryptId = route.params.encryptId;
              if (!encryptId) return [3 /*break*/, 4];
              _b.label = 1;
            case 1:
              _b.trys.push([1, 3,, 4]);
              return [4 /*yield*/, daoService.getUserLoginConf(encryptId)];
            case 2:
              res = _b.sent();
              list = (res.naviBarList || []).map(function (item) {
                return {
                  navBarName: item.title,
                  navBarText: item.content
                };
              });
              itemList.value = list;
              contestNavigationBarRespList.value = list;
              appendixUrlList.value = res.appendixUrlList || [];
              if ((_a = res === null || res === void 0 ? void 0 : res.appendixUrlList) === null || _a === void 0 ? void 0 : _a.length) {
                extraFileHtml.value = createExtraFileHtml(res.appendixUrlList);
              } else {
                extraFileHtml.value = '';
              }
              return [3 /*break*/, 4];
            case 3:
              _e_1 = _b.sent();
              _message.error('获取活动介绍配置失败');
              return [3 /*break*/, 4];
            case 4:
              return [2 /*return*/];
          }
        });
      });
    });
    var onGoBack = function () {
      router.push({
        name: 'ContestLogin',
        params: {
          suffix: route.params.suffix,
          _: route.params.suffix ? 's' : undefined,
          encryptId: route.params.encryptId
        }
      });
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("header", {
        class: "intro-header"
      }, [_createElementVNode("div", {
        class: "left-area"
      }, [_createElementVNode("div", {
        class: "back-area",
        onClick: onGoBack
      }, _hoisted_4), _hoisted_5])]), _createElementVNode("div", _hoisted_6, [_createVNode(ItemDetailNavBar, {
        list: contestNavigationBarRespList.value,
        appendixUrlList: appendixUrlList.value
      }, null, 8, ["list", "appendixUrlList"]), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemList.value, function (item, index) {
        return _openBlock(), _createBlock(ItemDetailBox, {
          key: index,
          title: item.navBarName,
          desc: item.navBarText
        }, null, 8, ["title", "desc"]);
      }), 128)), _hoisted_8, appendixUrlList.value && appendixUrlList.value.length ? (_openBlock(), _createBlock(ItemDetailBox, {
        key: "appendixUrlList",
        title: "活动文件",
        desc: extraFileHtml.value
      }, null, 8, ["desc"])) : _createCommentVNode("", true)])])]);
    };
  }
});